import script from "./AlertMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertMessage.vue?vue&type=script&setup=true&lang=js"

import "./AlertMessage.vue?vue&type=style&index=0&id=76ecc158&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76ecc158"]])

export default __exports__